import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SeasonalEffects from "./SeasonalEffects";

// The strip across the top of the site during a seasonal theme. Its wording
// is in the translation files under seasons.<id>.
export default function SeasonalBanner({ season, onDismiss, effects }) {
  const { t } = useTranslation();
  return (
    <div
      className={`season-banner season-banner--${season.id}`}
      style={{ "--from": season.colors.from, "--to": season.colors.to, "--text": season.colors.text }}
      role="region"
      aria-label={t(`seasons.${season.id}.title`)}
    >
      {effects && <SeasonalEffects effect={season.effect} className="season-fx--banner" />}
      <div className="container season-banner__inner">
        <span className="season-banner__emoji" aria-hidden="true">
          {season.emoji}
        </span>
        <p className="season-banner__text">
          <strong>{t(`seasons.${season.id}.title`)}</strong>
          <span>{t(`seasons.${season.id}.text`)}</span>
        </p>
        <Link to={season.link} className="season-banner__cta">
          {t(`seasons.${season.id}.cta`)} →
        </Link>
        {onDismiss && (
          <button type="button" className="season-banner__close" onClick={onDismiss} aria-label={t("seasons.close")}>
            ×
          </button>
        )}
      </div>
    </div>
  );
}
